import { z } from 'zod';

import {
  AdditionalFiltersSchema,
  BasicFiltersSchema,
  SortSchema,
} from '@/entities/listing/typings/api-types';

import { SearchSource } from '../types/ws/websocket-message';

export const accommodationSearchSchema = z.object({
  ...BasicFiltersSchema.shape,
  ...AdditionalFiltersSchema.shape,
  ...SortSchema.shape,
  bookingType: z.union([
    z.literal('your-tour'),
    z.literal('accommodation'),
    z.literal('excursion'),
  ]),
  searchSource: z.nativeEnum(SearchSource).optional(),
});
